import { put, select } from "redux-saga/effects";
import { AUTH } from "../../constants/state";
import actionTypes from "../../actions/actionTypes";

export function* validSessionResponse(response) {
    if(
        !response ||
        !response.hasOwnProperty('status') ||
        !response.hasOwnProperty('data') ||
        !response.data ||
        !response.data.hasOwnProperty('expired') ||
        !response.data.hasOwnProperty('state') ||
        !response.data.hasOwnProperty('user_name') ||
        !response.data.hasOwnProperty('alive_until') ||
        !response.data.hasOwnProperty('bypass_session') ||
        !response.data.hasOwnProperty('caps')
    ) {
        return yield false
    } else {
        return yield true
    }
}


export const getSessionExpired = state => ({
    expired: state.getIn([AUTH, 'session', 'expired']),
    bypass: state.getIn([AUTH, 'session', 'bypass'])
})


export const getSessionAlive = state => state.getIn([AUTH, 'session', 'aliveUntil'])

export const getSessionBypass = state => state.getIn([AUTH, 'session', 'bypass'])


export function* isSessionExpired(offset = 0) {
    const { expired } = yield select(getSessionExpired)

    return yield checkIsExpired(expired, offset)
}


export const checkIsExpired = (expired, offset) => (
    !expired || (expired - offset) < Math.floor(Date.now() / 1000)
)


export function* isSessionAlive() {
    const aliveUntil = yield select(getSessionAlive)

    return aliveUntil && aliveUntil > Math.ceil(Date.now() / 1000)
}


export function* putSessionData(data) {
    yield put({
        type: actionTypes.AUTH_SET_SESSION_DATA,
        payload: {
            expired: data && data.expired ? data.expired : false,
            state: data && data.state ? data.state : false,
            userName: data && data.user_name ? data.user_name : false,
            aliveUntil: data && data.alive_until ? data.alive_until : false,
            bypass: data && data.bypass_session ? data.bypass_session : false
        }
    })
}

export function* putCapsData(caps) {
    if(!caps || 'object' !== typeof caps)  {
        throw new Error('Invalid caps')
    }

    yield put({
        type: actionTypes.AUTH_SET_CAPS_DATA,
        payload: {
            caps: caps
        }
    })
}